import { render, staticRenderFns } from "./TopicFoot.vue?vue&type=template&id=4d6de844&scoped=true"
import script from "./TopicFoot.vue?vue&type=script&lang=js"
export * from "./TopicFoot.vue?vue&type=script&lang=js"
import style0 from "./TopicFoot.vue?vue&type=style&index=0&id=4d6de844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6de844",
  null
  
)

export default component.exports